import { useEffect, useRef } from "react";

import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import {
  getTeamsPurchaseSeats,
  TEAMS_PURCHASE_SEATS_PARAM,
} from "../utils/teamsActivation";

export const teamsPurchaseToastText = (seats: number) =>
  `Payment done. OVOU Teams for ${seats} people is ready to set up.`;

/** Shows the purchase toast once on arrival, then drops the parameter. */
export const useTeamsPurchaseToast = (): void => {
  const history = useHistory();
  const { addToast } = useToasts();
  const shown = useRef(false);

  useEffect(() => {
    const { pathname, search } = history.location;
    const seats = getTeamsPurchaseSeats(search);
    if (seats === null || shown.current) return;
    shown.current = true;
    addToast(teamsPurchaseToastText(seats), { appearance: "success" });

    const params = new URLSearchParams(search);
    params.delete(TEAMS_PURCHASE_SEATS_PARAM);
    const rest = params.toString();
    history.replace(rest ? `${pathname}?${rest}` : pathname);
  }, [history, addToast]);
};
